import React from 'react';
import type { CSSProperties, FunctionComponent } from 'react';
import cx from 'classnames';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { forTemplate } from '@trello/i18n';
// eslint-disable-next-line no-restricted-imports
import Textfield from '@atlaskit/textfield';
import type { SearchTheme } from './useSearchTheme';
import styles from './CrossProductSearchInputSkeleton.less';

const format = forTemplate('cross_product_search');

interface Props {
  theme: SearchTheme;
}

export const CrossProductSearchInputSkeleton: FunctionComponent<Props> = ({
  theme,
}) => (
  <div
    className={cx(styles.searchInputSkeleton)}
    style={
      {
        '--background-color': theme.default.backgroundColor,
        '--border-color': theme.default.borderColor,
        '--color': theme.default.color,
      } as CSSProperties
    }
  >
    <Textfield
      elemBeforeInput={
        <SearchIcon
          label="search"
          primaryColor={theme.default.color}
          size="small"
        />
      }
      placeholder={format('search')}
    />
  </div>
);
